import { useEffect } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";

const LOGO_URL = "https://media.routeyou.com/logo/powered-white.svg";
const LOGO_TITLE = "Gerealiseerd door RouteYou - www.routeyou.com";
const ROUTEYOU_URL = "https://www.routeyou.com/";

const RouteYouLogoControl = () => {
  const map = useMap();

  useEffect(() => {
    const control = L.control({ position: "bottomleft" });

    control.onAdd = function () {
      const link = L.DomUtil.create(
        "a",
        "leaflet-control c-routedetail-leaflet-map__routeyou-logo"
      );
      link.href = ROUTEYOU_URL;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      link.title = LOGO_TITLE;

      const image = L.DomUtil.create("img", "", link);
      image.src = LOGO_URL;
      image.alt = LOGO_TITLE;

      L.DomEvent.disableClickPropagation(link);
      return link;
    };

    map.addControl(control);

    return () => {
      map.removeControl(control);
    };
  }, [map]);

  return null;
};

export default RouteYouLogoControl;
